import type { DateValue } from '@internationalized/date';

import type { Currency } from '$saga/utils/currency';

// Typing for the search form
export type FilterFormValues = {
    destination: string[];
    theme: string[];
    startDate: DateValue | undefined;
    endDate: DateValue | undefined;
    months: string[]; // Array of month identifiers (format: "YYYY-MM")
    flexibility: number;
    nbPax: string;
    // adults: string;
    // children: string;
    // childrenAges: string[];
    levels: string[];
    types: string[];
    tags: string[];
    resorts: string[];
    budgetMin: number | null;
    budgetMax: number | null;
    durationMin: number | null;
    durationMax: number | null;
    bestReviewed: boolean;
    exclusiveSport: boolean;
    keywords: string | null;
};

// Typing for the label displayed
export type FilterFormLabels = {
    destination: string[];
    theme: string[];
    startDate: DateValue | undefined;
    endDate: DateValue | undefined;
    months: string[]; // Array of formatted month labels (e.g., "Mar 2026")
    nbPax: string;
    levels: string;
    types: string;
    tags: string;
    budget: string;
    duration: string;
};

// used for mobile modal options listing
export enum FilterType {
    SELECTION,
    DESTINATION,
    SPORT,
    STARTDATE,
    PAX,
    LEVELS,
    TYPES,
    TAGS,
    BUDGET,
    DURATION,
}

// typing for param passed from the url
export type SearchForm = {
    // if coming from menu, its int, if from search, its string -> TODO fix in SearchFormModel ?
    destinations: number[] | string[] | null;
    sports: number[] | string[] | null;
    flexibility: number | null;
    nbPax: number | null;
    groupOnly: boolean | null;
    startDate: { date: string } | null;
    endDate: { date: string } | null;
    months: string[] | null; // Array of month identifiers (format: "YYYY-MM")
    levels: string[] | null;
    types: string[] | null;
    tags: string[] | null;
    resorts: number[] | string[] | null;
    budgetMin: number | null;
    budgetMax: number | null;
    durationMin: number | null;
    durationMax: number | null;
    sort: string | null;
    keywords: string | null;
    currency: Currency;
    bestReviewed: boolean | null;
    exclusiveSport: boolean | null;
};

export type PaxFilterValues = {
    adultsValue: string;
    childrenValue: string;
    childrenAges: string[];
};

export enum Sorting {
    DEFAULT = 'default',
    PRICE_ASC = 'price_asc',
    PRICE_DESC = 'price_desc',
    SORT_SPORT_RANKING = 'sport_ranking',
    SORT_LANDING_PERSONALIZED = 'personalized',
    SORT_LANDING_DESTINATION_PERSONALIZED = 'destination_personalized',
    SORT_LANDING_TAG_PERSONALIZED = 'tag_personalized',
    DURATION_DESC = 'duration_desc',
    DURATION_ASC = 'duration_asc',
    REVIEWS_DESC = 'reviews_desc',
    DEPARTURE_DATE = 'departure_date',
}

export type LandingPageContext = {
    isLandingPage: boolean;
    type: 'sport' | 'theme' | 'destination' | 'landing' | 'lastminute' | null;
    pillarFilters: {
        sports?: string[];
        destinations?: string[];
        tags?: string[];
        hasDateRange?: boolean;
    };
};
